import script from "./TransitionAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./TransitionAnimation.vue?vue&type=script&setup=true&lang=js"

import "./TransitionAnimation.vue?vue&type=style&index=0&id=7aac97e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aac97e8"]])

export default __exports__